import { ReminderEntityTypeEnum } from "web_myplann/Infrastructure/Api/Api";

/**
 * Zbytek API serializuje enumy jako *názvy* casů ("Portfolio"), a swagger je tak
 * i dokumentuje. Výjimkou je `GET /v2/reminders/types`, který dělá
 * `ReminderEntityTypeEnum::tryFrom($entity)`
 * (api_myplann/moduleApi/Reminder/Action/ListReminderTypesAction.php:64),
 * takže query param musí být *hodnota* enumu - "portfolio" / "property".
 *
 * Mapování je schválně na jednom místě: až BE tohle místo srovná se zbytkem
 * API, je to jeden soubor ke smazání.
 */
const WIRE_VALUE_BY_ENTITY_TYPE: Record<ReminderEntityTypeEnum, string> = {
	[ReminderEntityTypeEnum.Portfolio]: "portfolio",
	[ReminderEntityTypeEnum.Property]: "property",
	[ReminderEntityTypeEnum.IdentificationDocument]: "identificationDocument",
};

export const toReminderEntityWireValue = (
	entityType: ReminderEntityTypeEnum,
): string => WIRE_VALUE_BY_ENTITY_TYPE[entityType];
